const Coin = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="112"
      height="100"
      viewBox="0 0 112 100"
      fill="none"
    >
      <g filter="url(#filter0_f_475_3886)">
        <path
          d="M69.4541 66.2352C69.4541 66.2352 70.2564 67.3959 72.8119 69.0246C73.0031 69.145 73.2037 69.2694 73.415 69.3951C74.2174 69.8751 75.1601 70.386 76.274 70.9155L76.5415 64.0956C76.5415 64.0956 80.0183 64.363 83.094 63.0258C82.7396 62.8493 81.2125 62.0269 79.0167 60.3245C78.8201 60.1734 78.6156 60.013 78.4096 59.8458C77.4388 59.0649 76.3569 58.1248 75.2002 57.0082C73.4658 59.9501 69.4541 66.2352 69.4541 66.2352Z"
          fill="#5440F0"
        />
        <path
          d="M41.6399 65.834C41.6399 65.834 40.8375 66.9947 38.2821 68.6235C38.0908 68.7438 37.8902 68.8682 37.679 68.9939C36.8766 69.4739 35.9405 69.9848 34.8199 70.5143L34.5525 63.6944C34.5525 63.6944 31.0757 63.9618 28 62.6246C28.3544 62.4481 29.8815 61.6257 32.0773 59.9234C32.2738 59.7722 32.4784 59.6118 32.6844 59.4446C33.6552 58.6637 34.737 57.7236 35.8937 56.607C37.6281 59.5489 41.6399 65.834 41.6399 65.834Z"
          fill="#5440F0"
        />
        <path
          d="M38.282 68.6235C38.0907 68.7438 37.8901 68.8682 37.6789 68.9939C37.2015 67.444 35.2986 64.0207 34.5524 63.0258C34.0273 62.3119 33.4459 61.6412 32.814 61.0199C32.5666 60.7725 32.2684 60.2711 32.0771 59.9234C32.2737 59.7723 32.4783 59.6118 32.6843 59.4446C32.9276 59.8298 33.2967 60.4061 33.6203 60.8862C34.1552 61.6885 37.4983 65.9677 37.8995 66.7701C38.1629 67.3023 38.2512 68.1274 38.282 68.6235Z"
          fill="#5440F0"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M55.5471 71.3167C67.5114 71.3167 77.2104 61.6176 77.2104 49.6533C77.2104 37.689 67.5114 27.99 55.5471 27.99C43.5828 27.99 33.8838 37.689 33.8838 49.6533C33.8838 61.6176 43.5828 71.3167 55.5471 71.3167ZM55.5471 66.1014C64.6312 66.1014 71.9952 58.7374 71.9952 49.6533C71.9952 40.5693 64.6312 33.2052 55.5471 33.2052C46.4631 33.2052 39.099 40.5693 39.099 49.6533C39.099 58.7374 46.4631 66.1014 55.5471 66.1014Z"
          fill="#5440F0"
        />
        <mask
          id="mask0_475_3886"
          style={{ maskType: "alpha" }}
          maskUnits="userSpaceOnUse"
          x="33"
          y="27"
          width="45"
          height="45"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M55.5471 71.3167C67.5114 71.3167 77.2104 61.6176 77.2104 49.6533C77.2104 37.689 67.5114 27.99 55.5471 27.99C43.5828 27.99 33.8838 37.689 33.8838 49.6533C33.8838 61.6176 43.5828 71.3167 55.5471 71.3167ZM55.5471 66.1014C64.6312 66.1014 71.9952 58.7374 71.9952 49.6533C71.9952 40.5693 64.6312 33.2052 55.5471 33.2052C46.4631 33.2052 39.099 40.5693 39.099 49.6533C39.099 58.7374 46.4631 66.1014 55.5471 66.1014Z"
            fill="#6C7E92"
          />
        </mask>
        <g mask="url(#mask0_475_3886)">
          <g filter="url(#filter1_f_475_3886)">
            <ellipse
              cx="42.3057"
              cy="35.3811"
              rx="4.9478"
              ry="10.0293"
              transform="rotate(42.5525 42.3057 35.3811)"
              fill="#5440F0"
            />
          </g>
          <g filter="url(#filter2_f_475_3886)">
            <ellipse
              cx="67.6088"
              cy="64.3892"
              rx="4.9478"
              ry="10.0293"
              transform="rotate(-135 67.6088 64.3892)"
              fill="#5440F0"
            />
          </g>
        </g>
        <circle cx="55.5467" cy="49.6533" r="16.4481" fill="#5440F0" />
        <circle
          cx="55.5467"
          cy="49.6533"
          r="16.1138"
          stroke="#5440F0"
          strokeWidth="0.668621"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M55.5471 67.3049C65.2958 67.3049 73.1987 59.402 73.1987 49.6533C73.1987 39.9046 65.2958 32.0017 55.5471 32.0017C45.7984 32.0017 37.8955 39.9046 37.8955 49.6533C37.8955 59.402 45.7984 67.3049 55.5471 67.3049ZM55.5471 66.1014C64.6311 66.1014 71.9952 58.7374 71.9952 49.6533C71.9952 40.5693 64.6311 33.2052 55.5471 33.2052C46.4631 33.2052 39.099 40.5693 39.099 49.6533C39.099 58.7374 46.4631 66.1014 55.5471 66.1014Z"
          fill="#5440F0"
        />
        <path
          d="M59.691 57.5026C59.4661 57.5023 59.2448 57.4467 59.0464 57.3407L55.6659 55.5649C55.6209 55.5412 55.5709 55.5289 55.5201 55.5289C55.4693 55.5289 55.4193 55.5412 55.3744 55.5649L51.9938 57.3407C51.7955 57.4467 51.5741 57.5023 51.3493 57.5026C51.1477 57.5019 50.9486 57.4574 50.766 57.372C50.5833 57.2866 50.4215 57.1625 50.2917 57.0083C50.1619 56.854 50.0672 56.6734 50.0143 56.4788C49.9614 56.2843 49.9515 56.0806 49.9853 55.8818L50.6312 52.1188C50.6398 52.0686 50.6361 52.0169 50.6202 51.9685C50.6044 51.92 50.5769 51.8761 50.5402 51.8407L47.8069 49.1755C47.6223 48.9952 47.4917 48.7668 47.4299 48.5161C47.3681 48.2655 47.3776 48.0026 47.4573 47.757C47.5369 47.5115 47.6836 47.2931 47.8808 47.1264C48.078 46.9598 48.3178 46.8516 48.5732 46.814L52.3522 46.2657C52.4026 46.2581 52.4505 46.2385 52.4917 46.2084C52.5329 46.1784 52.5662 46.1389 52.5889 46.0932L54.2792 42.6685C54.3935 42.437 54.5703 42.2421 54.7896 42.1058C55.0089 41.9696 55.2619 41.8973 55.5201 41.8973C55.7783 41.8973 56.0314 41.9696 56.2507 42.1058C56.47 42.2421 56.6468 42.437 56.7611 42.6685L58.4514 46.0932C58.474 46.1389 58.5074 46.1784 58.5486 46.2084C58.5898 46.2385 58.6376 46.2581 58.6881 46.2657L62.4671 46.814C62.7225 46.8516 62.9623 46.9598 63.1595 47.1264C63.3566 47.2931 63.5033 47.5115 63.583 47.757C63.6626 48.0026 63.6721 48.2655 63.6104 48.5161C63.5486 48.7668 63.418 48.9952 63.2333 49.1755L60.5 51.8407C60.4633 51.8761 60.4359 51.92 60.42 51.9685C60.4042 52.0169 60.4004 52.0686 60.4091 52.1188L61.055 55.8818C61.0888 56.0806 61.0789 56.2843 61.026 56.4788C60.973 56.6734 60.8784 56.854 60.7486 57.0083C60.6188 57.1625 60.4569 57.2866 60.2743 57.372C60.0916 57.4574 59.8926 57.5019 59.691 57.5026Z"
          fill="#5440F0"
        />
        <path
          d="M56.2821 42.9061L57.9724 46.3308C58.0335 46.454 58.1236 46.5606 58.2349 46.6414C58.3463 46.7222 58.4755 46.7748 58.6116 46.7948L62.3906 47.3444C62.5474 47.3672 62.6947 47.4334 62.8158 47.5355C62.9369 47.6376 63.0271 47.7716 63.076 47.9223C63.125 48.0729 63.1308 48.2343 63.0929 48.3881C63.055 48.5419 62.9748 48.6821 62.8613 48.7927L60.1267 51.4578C60.0282 51.554 59.9547 51.6726 59.9123 51.8035C59.8699 51.9344 59.8599 52.0737 59.8833 52.2093L60.5278 55.9737C60.555 56.1298 60.5378 56.2905 60.4782 56.4374C60.4186 56.5843 60.3191 56.7116 60.1908 56.8047C60.0626 56.8979 59.9107 56.9532 59.7526 56.9645C59.5945 56.9757 59.4364 56.9424 59.2962 56.8683L55.9224 55.0924C55.8004 55.0279 55.6645 54.9942 55.5266 54.9942C55.3886 54.9942 55.2527 55.0279 55.1307 55.0924L51.7462 56.8683C51.606 56.9424 51.4479 56.9757 51.2898 56.9645C51.1317 56.9532 50.9799 56.8979 50.8516 56.8047C50.7234 56.7116 50.6238 56.5843 50.5642 56.4374C50.5046 56.2905 50.4874 56.1298 50.5146 55.9737L51.1591 52.2093C51.1825 52.0737 51.1725 51.9344 51.1302 51.8035C51.0878 51.6726 51.0142 51.554 50.9157 51.4578L48.1811 48.7927C48.0677 48.6821 47.9875 48.5419 47.9495 48.3881C47.9116 48.2343 47.9174 48.0729 47.9664 47.9223C48.0154 47.7716 48.1055 47.6376 48.2266 47.5355C48.3477 47.4334 48.495 47.3672 48.6518 47.3444L52.4308 46.7948C52.5669 46.7748 52.6962 46.7222 52.8075 46.6414C52.9188 46.5606 53.0089 46.454 53.07 46.3308L54.7603 42.9061C54.8302 42.7639 54.9385 42.6442 55.073 42.5604C55.2075 42.4766 55.3628 42.4323 55.5212 42.4323C55.6797 42.4323 55.8349 42.4766 55.9694 42.5604C56.1039 42.6442 56.2122 42.7639 56.2821 42.9061Z"
          fill="#5440F0"
        />
        <path
          opacity="0.15"
          d="M72.5301 36.214C71.5121 37.4323 70.5861 38.373 69.4566 39.4667C69.3729 39.5498 69.2892 39.6328 69.2056 39.7159C69.1498 39.7713 69.1079 39.8128 69.0522 39.8682C68.843 40.062 68.6338 40.2697 68.4107 40.4635C68.327 40.5327 68.2573 40.6019 68.1736 40.685C68.1179 40.7265 68.0621 40.7819 68.0203 40.8234C67.9505 40.8926 67.8808 40.948 67.8111 41.0034C60.3925 47.5239 50.966 51.4972 41.0095 52.2171C40.9119 52.2171 40.8282 52.2309 40.7306 52.2309C40.6609 52.2309 40.5912 52.2447 40.5214 52.2447C40.4099 52.2447 40.3123 52.2586 40.2007 52.2586C39.8381 52.2724 39.4756 52.3001 39.113 52.3001C39.0015 52.3001 38.876 52.314 38.7644 52.314C38.4855 52.3278 38.2066 52.3278 37.9417 52.3278C36.6448 52.3278 35.348 52.2863 34.0372 52.1755C33.9396 51.3587 33.8838 50.5142 33.8838 49.6698C33.8838 37.6947 43.659 27.99 55.7071 27.99C61.1316 27.99 65.9679 30.0718 69.7888 33.339C70.7788 34.1834 71.6934 35.2034 72.5301 36.214Z"
          fill="#5440F0"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M55.5471 71.3167C67.5114 71.3167 77.2104 61.6176 77.2104 49.6533C77.2104 37.689 67.5114 27.99 55.5471 27.99C43.5828 27.99 33.8838 37.689 33.8838 49.6533C33.8838 61.6176 43.5828 71.3167 55.5471 71.3167ZM55.5471 66.1014C64.6312 66.1014 71.9952 58.7374 71.9952 49.6533C71.9952 40.5693 64.6312 33.2052 55.5471 33.2052C46.4631 33.2052 39.099 40.5693 39.099 49.6533C39.099 58.7374 46.4631 66.1014 55.5471 66.1014Z"
        fill="#222323"
      />
      <mask id="path-15-inside-1_475_3886" fill="white">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M55.5471 71.3167C67.5114 71.3167 77.2104 61.6176 77.2104 49.6533C77.2104 37.689 67.5114 27.99 55.5471 27.99C43.5828 27.99 33.8838 37.689 33.8838 49.6533C33.8838 61.6176 43.5828 71.3167 55.5471 71.3167ZM55.5471 66.1014C64.6312 66.1014 71.9952 58.7374 71.9952 49.6533C71.9952 40.5693 64.6312 33.2052 55.5471 33.2052C46.4631 33.2052 39.099 40.5693 39.099 49.6533C39.099 58.7374 46.4631 66.1014 55.5471 66.1014Z"
        />
      </mask>
      <path
        d="M76.7104 49.6533C76.7104 61.3415 67.2353 70.8167 55.5471 70.8167V71.8167C67.7876 71.8167 77.7104 61.8938 77.7104 49.6533H76.7104ZM55.5471 28.49C67.2353 28.49 76.7104 37.9651 76.7104 49.6533H77.7104C77.7104 37.4129 67.7876 27.49 55.5471 27.49V28.49ZM34.3838 49.6533C34.3838 37.9651 43.8589 28.49 55.5471 28.49V27.49C43.3067 27.49 33.3838 37.4129 33.3838 49.6533H34.3838ZM55.5471 70.8167C43.8589 70.8167 34.3838 61.3415 34.3838 49.6533H33.3838C33.3838 61.8938 43.3067 71.8167 55.5471 71.8167V70.8167ZM71.4952 49.6533C71.4952 58.4612 64.355 65.6014 55.5471 65.6014V66.6014C64.9073 66.6014 72.4952 59.0135 72.4952 49.6533H71.4952ZM55.5471 33.7052C64.355 33.7052 71.4952 40.8454 71.4952 49.6533H72.4952C72.4952 40.2932 64.9073 32.7052 55.5471 32.7052V33.7052ZM39.599 49.6533C39.599 40.8454 46.7392 33.7052 55.5471 33.7052V32.7052C46.187 32.7052 38.599 40.2932 38.599 49.6533H39.599ZM55.5471 65.6014C46.7392 65.6014 39.599 58.4612 39.599 49.6533H38.599C38.599 59.0135 46.187 66.6014 55.5471 66.6014V65.6014Z"
        fill="url(#paint0_linear_475_3886)"
        mask="url(#path-15-inside-1_475_3886)"
      />
      <mask
        id="mask1_475_3886"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="33"
        y="27"
        width="45"
        height="45"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M55.5471 71.3167C67.5114 71.3167 77.2104 61.6176 77.2104 49.6533C77.2104 37.689 67.5114 27.99 55.5471 27.99C43.5828 27.99 33.8838 37.689 33.8838 49.6533C33.8838 61.6176 43.5828 71.3167 55.5471 71.3167ZM55.5471 66.1014C64.6312 66.1014 71.9952 58.7374 71.9952 49.6533C71.9952 40.5693 64.6312 33.2052 55.5471 33.2052C46.4631 33.2052 39.099 40.5693 39.099 49.6533C39.099 58.7374 46.4631 66.1014 55.5471 66.1014Z"
          fill="#6C7E92"
        />
      </mask>
      <g mask="url(#mask1_475_3886)">
        <g filter="url(#filter3_f_475_3886)">
          <ellipse
            cx="42.3057"
            cy="35.3811"
            rx="4.9478"
            ry="10.0293"
            transform="rotate(42.5525 42.3057 35.3811)"
            fill="#F0F2F7"
          />
        </g>
        <g filter="url(#filter4_f_475_3886)">
          <ellipse
            cx="67.6088"
            cy="64.3892"
            rx="4.9478"
            ry="10.0293"
            transform="rotate(-135 67.6088 64.3892)"
            fill="#F0F2F7"
          />
        </g>
      </g>
      <circle cx="55.5467" cy="49.6533" r="16.4481" fill="#222323" />
      <circle
        cx="55.5467"
        cy="49.6533"
        r="16.1138"
        stroke="url(#paint1_linear_475_3886)"
        strokeWidth="0.668621"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M55.5471 67.3049C65.2958 67.3049 73.1987 59.402 73.1987 49.6533C73.1987 39.9046 65.2958 32.0017 55.5471 32.0017C45.7984 32.0017 37.8955 39.9046 37.8955 49.6533C37.8955 59.402 45.7984 67.3049 55.5471 67.3049ZM55.5471 66.1014C64.6311 66.1014 71.9952 58.7374 71.9952 49.6533C71.9952 40.5693 64.6311 33.2052 55.5471 33.2052C46.4631 33.2052 39.099 40.5693 39.099 49.6533C39.099 58.7374 46.4631 66.1014 55.5471 66.1014Z"
        fill="url(#paint2_linear_475_3886)"
      />
      <path
        d="M59.691 57.5026C59.4661 57.5023 59.2448 57.4467 59.0464 57.3407L55.6659 55.5649C55.6209 55.5412 55.5709 55.5289 55.5201 55.5289C55.4693 55.5289 55.4193 55.5412 55.3744 55.5649L51.9938 57.3407C51.7955 57.4467 51.5741 57.5023 51.3493 57.5026C51.1477 57.5019 50.9486 57.4574 50.766 57.372C50.5833 57.2866 50.4215 57.1625 50.2917 57.0083C50.1619 56.854 50.0672 56.6734 50.0143 56.4788C49.9614 56.2843 49.9515 56.0806 49.9853 55.8818L50.6312 52.1188C50.6398 52.0686 50.6361 52.0169 50.6202 51.9685C50.6044 51.92 50.5769 51.8761 50.5402 51.8407L47.8069 49.1755C47.6223 48.9952 47.4917 48.7668 47.4299 48.5161C47.3681 48.2655 47.3776 48.0026 47.4573 47.757C47.5369 47.5115 47.6836 47.2931 47.8808 47.1264C48.078 46.9598 48.3178 46.8516 48.5732 46.814L52.3522 46.2657C52.4026 46.2581 52.4505 46.2385 52.4917 46.2084C52.5329 46.1784 52.5662 46.1389 52.5889 46.0932L54.2792 42.6685C54.3935 42.437 54.5703 42.2421 54.7896 42.1058C55.0089 41.9696 55.2619 41.8973 55.5201 41.8973C55.7783 41.8973 56.0314 41.9696 56.2507 42.1058C56.47 42.2421 56.6468 42.437 56.7611 42.6685L58.4514 46.0932C58.474 46.1389 58.5074 46.1784 58.5486 46.2084C58.5898 46.2385 58.6376 46.2581 58.6881 46.2657L62.4671 46.814C62.7225 46.8516 62.9623 46.9598 63.1595 47.1264C63.3566 47.2931 63.5033 47.5115 63.583 47.757C63.6626 48.0026 63.6721 48.2655 63.6104 48.5161C63.5486 48.7668 63.418 48.9952 63.2333 49.1755L60.5 51.8407C60.4633 51.8761 60.4359 51.92 60.42 51.9685C60.4042 52.0169 60.4004 52.0686 60.4091 52.1188L61.055 55.8818C61.0888 56.0806 61.0789 56.2843 61.026 56.4788C60.973 56.6734 60.8784 56.854 60.7486 57.0083C60.6188 57.1625 60.4569 57.2866 60.2743 57.372C60.0916 57.4574 59.8926 57.5019 59.691 57.5026Z"
        fill="url(#paint3_linear_475_3886)"
      />
      <path
        d="M56.2821 42.9061L57.9724 46.3308C58.0335 46.454 58.1236 46.5606 58.2349 46.6414C58.3463 46.7222 58.4755 46.7748 58.6116 46.7948L62.3906 47.3444C62.5474 47.3672 62.6947 47.4334 62.8158 47.5355C62.9369 47.6376 63.0271 47.7716 63.076 47.9223C63.125 48.0729 63.1308 48.2343 63.0929 48.3881C63.055 48.5419 62.9748 48.6821 62.8613 48.7927L60.1267 51.4578C60.0282 51.554 59.9547 51.6726 59.9123 51.8035C59.8699 51.9344 59.8599 52.0737 59.8833 52.2093L60.5278 55.9737C60.555 56.1298 60.5378 56.2905 60.4782 56.4374C60.4186 56.5843 60.3191 56.7116 60.1908 56.8047C60.0626 56.8979 59.9107 56.9532 59.7526 56.9645C59.5945 56.9757 59.4364 56.9424 59.2962 56.8683L55.9224 55.0924C55.8004 55.0279 55.6645 54.9942 55.5266 54.9942C55.3886 54.9942 55.2527 55.0279 55.1307 55.0924L51.7462 56.8683C51.606 56.9424 51.4479 56.9757 51.2898 56.9645C51.1317 56.9532 50.9799 56.8979 50.8516 56.8047C50.7234 56.7116 50.6238 56.5843 50.5642 56.4374C50.5046 56.2905 50.4874 56.1298 50.5146 55.9737L51.1591 52.2093C51.1825 52.0737 51.1725 51.9344 51.1302 51.8035C51.0878 51.6726 51.0142 51.554 50.9157 51.4578L48.1811 48.7927C48.0677 48.6821 47.9875 48.5419 47.9495 48.3881C47.9116 48.2343 47.9174 48.0729 47.9664 47.9223C48.0154 47.7716 48.1055 47.6376 48.2266 47.5355C48.3477 47.4334 48.495 47.3672 48.6518 47.3444L52.4308 46.7948C52.5669 46.7748 52.6962 46.7222 52.8075 46.6414C52.9188 46.5606 53.0089 46.454 53.07 46.3308L54.7603 42.9061C54.8302 42.7639 54.9385 42.6442 55.073 42.5604C55.2075 42.4766 55.3628 42.4323 55.5212 42.4323C55.6797 42.4323 55.8349 42.4766 55.9694 42.5604C56.1039 42.6442 56.2122 42.7639 56.2821 42.9061Z"
        fill="#808183"
      />
      <path
        opacity="0.15"
        d="M72.5301 36.214C71.5121 37.4323 70.5861 38.373 69.4566 39.4667C69.3729 39.5498 69.2892 39.6328 69.2056 39.7159C69.1498 39.7713 69.1079 39.8128 69.0522 39.8682C68.843 40.062 68.6338 40.2697 68.4107 40.4635C68.327 40.5327 68.2573 40.6019 68.1736 40.685C68.1179 40.7265 68.0621 40.7819 68.0203 40.8234C67.9505 40.8926 67.8808 40.948 67.8111 41.0034C60.3925 47.5239 50.966 51.4972 41.0095 52.2171C40.9119 52.2171 40.8282 52.2309 40.7306 52.2309C40.6609 52.2309 40.5912 52.2447 40.5214 52.2447C40.4099 52.2447 40.3123 52.2586 40.2007 52.2586C39.8381 52.2724 39.4756 52.3001 39.113 52.3001C39.0015 52.3001 38.876 52.314 38.7644 52.314C38.4855 52.3278 38.2066 52.3278 37.9417 52.3278C36.6448 52.3278 35.348 52.2863 34.0372 52.1755C33.9396 51.3587 33.8838 50.5142 33.8838 49.6698C33.8838 37.6947 43.659 27.99 55.7071 27.99C61.1316 27.99 65.9679 30.0718 69.7888 33.339C70.7788 34.1834 71.6934 35.2034 72.5301 36.214Z"
        fill="url(#paint4_linear_475_3886)"
      />
      <defs>
        <filter
          id="filter0_f_475_3886"
          x="0"
          y="-0.0100098"
          width="111.094"
          height="99.3267"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="14"
            result="effect1_foregroundBlur_475_3886"
          />
        </filter>
        <filter
          id="filter1_f_475_3886"
          x="26.7148"
          y="19.3788"
          width="31.1818"
          height="32.0046"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="3.94487"
            result="effect1_foregroundBlur_475_3886"
          />
        </filter>
        <filter
          id="filter2_f_475_3886"
          x="51.8095"
          y="48.5899"
          width="31.5988"
          height="31.5987"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="3.94487"
            result="effect1_foregroundBlur_475_3886"
          />
        </filter>
        <filter
          id="filter3_f_475_3886"
          x="26.7148"
          y="19.3788"
          width="31.1818"
          height="32.0046"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="3.94487"
            result="effect1_foregroundBlur_475_3886"
          />
        </filter>
        <filter
          id="filter4_f_475_3886"
          x="51.8095"
          y="48.5899"
          width="31.5988"
          height="31.5987"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="3.94487"
            result="effect1_foregroundBlur_475_3886"
          />
        </filter>
        <linearGradient
          id="paint0_linear_475_3886"
          x1="41"
          y1="28.3467"
          x2="55.5471"
          y2="71.3167"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0.4" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_475_3886"
          x1="55.5467"
          y1="33.2053"
          x2="55.5467"
          y2="66.1014"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#66686A" />
          <stop offset="1" stopColor="#66686A" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_475_3886"
          x1="55.5471"
          y1="32.0017"
          x2="55.5471"
          y2="67.3049"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#222323" />
          <stop offset="1" stopColor="#66686A" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_475_3886"
          x1="55.5201"
          y1="41.8973"
          x2="55.5201"
          y2="57.5026"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5440F0" />
          <stop offset="1" stopColor="#5440F0" stopOpacity="0.12" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_475_3886"
          x1="44.0954"
          y1="31.3296"
          x2="56.3332"
          y2="48.459"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.5084" stopColor="white" stopOpacity="0" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default Coin;
